import {  WBComponent } from "./WBComponent";

import { WBRenderProps } from "vagaro-website-rendering/src/components/Definitions/WBRenderProps";
import { wBComponentTypeNames } from "vagaro-website-rendering/src/components/Definitions/WBComponentTypeNames";
import {  defaultDropList } from "../Data/WBComponentDefaults";
import  { componentAttributeTypes } from "vagaro-website-rendering/src/components/Definitions/AttributeTypes";
import { getNodeComponentAttributeValue } from "vagaro-website-rendering/src/components/Definitions/LayoutNode";
import { GetNodeDomAttributes } from "vagaro-website-rendering/src/components/Utilities/GetNodeDomAttributes";
import { AttributeDefinition, AttributeInputType } from "../Data/WBData";
import { NoRecordsBanner } from "vagaro-website-rendering/src/components/OopsBanner";





export default class WBHTMLEmbed extends WBComponent{

    constructor(){
        super();
        this.typename = wBComponentTypeNames.htmlEmbed;

        this.displayName = "HTML";
        this.dropList = defaultDropList;
        this.editList = [ "html",componentAttributeTypes.customCSS,"width","height",componentAttributeTypes.visibility];
        this.primaryEditAttributes = ["html"];
        this.icon =<svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 640 512" fill="currentColor"><path d="M399.1 1.1c-12.7-3.9-26.1 3.1-30 15.8l-144 464c-3.9 12.7 3.1 26.1 15.8 30s26.1-3.1 30-15.8l144-464c3.9-12.7-3.1-26.1-15.8-30zm71.4 118.5c-9.1 9.7-8.6 24.9 1.1 33.9L580.9 256 471.6 358.5c-9.7 9.1-10.2 24.3-1.1 33.9s24.3 10.2 33.9 1.1l128-120c4.8-4.5 7.6-10.9 7.6-17.5s-2.7-13-7.6-17.5l-128-120c-9.7-9.1-24.9-8.6-33.9 1.1zm-301 0c-9.1-9.7-24.3-10.2-33.9-1.1l-128 120C2.7 243 0 249.4 0 256s2.7 13 7.6 17.5l128 120c9.7 9.1 24.9 8.6 33.9-1.1s8.6-24.9-1.1-33.9L59.1 256 168.4 153.5c9.7-9.1 10.2-24.3 1.1-33.9z"/></svg>
    }

    getComponentSpecificAttributeDefinitions(): AttributeDefinition[] {
        return [
            new AttributeDefinition("html","HTML Content","",AttributeInputType.HTMLField),
        ]
    }




    RenderLayout({component,children,screenSize,isEditor,userContext}:WBRenderProps): JSX.Element {

        let html = getNodeComponentAttributeValue(component,"html","").trim();
        const atts = GetNodeDomAttributes("v-html-embed max-100",component,screenSize,isEditor);


        let css = getNodeComponentAttributeValue(component,componentAttributeTypes.customCSS,"");


        if(html == ""){
            return <div {...atts}> <NoRecordsBanner showInLive={false}  message="No HTML Content"/></div>
        }


        if(!isEditor){
            //replace all double quotes with &quot; to prevent comments breaking the HTML
            html = html.replaceAll('"','&quot;').replace(/\/\/.*$/gm, '');;
            css = css.replaceAll('"','&quot;').replace(/\/\/.*$/gm, '');;

        }



        return <div {...atts}>  <iframe title="embed" className="w-full h-full" srcDoc={`<html><head></head><body><style>${css}</style>

        ${html}</body></html>`}  sandbox="allow-forms allow-popups allow-scripts" ></iframe></div>







    }

}
